import { UNLIMITED_PAGINATION_PARAMS } from 'constants/pagination';

import { createContext, useContext, useMemo } from 'react';

import { useGetList } from 'react-admin';
import { Direction } from 'types/embedded/direction';
import { TransactionType } from 'types/embedded/transactionType';

type GatewayRulesDictionaryContextData = {
  directions: Direction[];
  transactionTypes: TransactionType[];
};

const GatewayRulesDictionaryContext = createContext<GatewayRulesDictionaryContextData | null>(null);

export function GatewayRulesDictionaryProvider({ children }: { children: React.ReactNode }) {
  // @ts-ignore
  const { data: directions = [] } = useGetList<Direction>('directions', {
    pagination: UNLIMITED_PAGINATION_PARAMS,
  });
  const { data: transactionTypes = [] } = useGetList<TransactionType>('transaction_types');

  const value = useMemo(() => ({ directions, transactionTypes }), [directions, transactionTypes]);

  return (
    <GatewayRulesDictionaryContext.Provider value={value}>
      {children}
    </GatewayRulesDictionaryContext.Provider>
  );
}

export function useGatewayRulesDictionaryContext(): GatewayRulesDictionaryContextData {
  const context = useContext(GatewayRulesDictionaryContext);
  if (!context) {
    throw new Error(
      'Can not `useGatewayRulesDictionaryContext` outside of `GatewayRulesDictionaryProvider`',
    );
  }
  return context;
}
